import { UPDATE_PAYMENT_ERROR_NOTIFICATION } from "./types";

export const updatePaymentError = () => dispatch => {
    dispatch({ type: UPDATE_PAYMENT_ERROR_NOTIFICATION, payload: "" })
};